import type React from 'react';
import { Navigate } from 'react-router';
import { permissionToUrl } from '@/constants';
import usePermission from '@/hooks/usePermission';
import { useAuthStore } from '@/store';
import UnderDevelopment from './UnderDevelopment';

const WithPageConfig = ({
	children,
	path,
}: {
	children: React.ReactNode;
	path: string;
}) => {
	const pageConfig = useAuthStore((state) => state.pageConfig);
	const { hasPermission } = usePermission();

	// For root path, check if user has Dashboard permission
	// If not, redirect to their first available route
  // This prevents the flash of Dashboard before redirect happens in Layout component
	if (path === '/' && !hasPermission(['Dashboard:Visualize'])) {
		const firstMatchedRouteAsPerPermission = Object.entries(
			permissionToUrl,
		).find(([permission]) => {
			return hasPermission([permission]);
		});

		return (
			<Navigate
				to={firstMatchedRouteAsPerPermission?.[1] || '/profile'}
				replace
			/>
		);
	}

	// Check if path exists in pageConfig.underDevelopmentPages array
	const underDevelopmentPages = pageConfig?.underDevelopmentPages;
	const pathExists =
		Array.isArray(underDevelopmentPages) &&
		underDevelopmentPages.includes(path);

	if (pathExists) {
		return <UnderDevelopment />;
	}

	return <>{children}</>;
};

export default WithPageConfig;
